import React from 'react'
import {connect} from 'react-redux'
import './defaultUserPicture.css'

class DefaultUserPicture extends React.Component {
  render() {
    const classNames = [this.props.className, 'default-user-picture']
    const backgroundColors = {
      'A':'#50BF14',
      'B':'#0D8EC2',
      'C': '#FF6713',
      'D': '#A84CC5',
      'E': '#423BA6',
      'F': '#0CB1B1',
      'G': '#00AE6E',
      'H': '#FB9E10',
      'I': '#D73D75',
      'J': '#08748F',
      'K': '#236CDA',
      'L':'#50BF14',
      'M':'#0D8EC2',
      'N': '#FF6713',
      'O': '#A84CC5',
      'P': '#423BA6',
      'Q': '#0CB1B1',
      'R': '#00AE6E',
      'S': '#FB9E10',
      'T': '#D73D75',
      'U': '#08748F',
      'V': '#236CDA',
      'W':'#50BF14',
      'X':'#0D8EC2',
      'Y': '#FF6713',
      'Z': '#A84CC5',
      '': '#A84CC5'
    }

    const profilePicture = this.props.profilePicture

    const initial = this.props.displayName ? this.props.displayName.toUpperCase().charAt(0) : ''
    const style = {
      backgroundColor: backgroundColors[initial],
    }
    if (profilePicture) {
      return (
        <img className={classNames.join(' ')} src={ `${window.CDN_URL}/${profilePicture }` } alt="" />
      )
    } else {
      return (
        <div
          style={style}
          className={classNames.join(' ')}>
          <svg height="100%" width="100%" viewBox="0 0 30 30">
            <text
              x="50%"
              y="50%"
              fill="white"
              alignmentBaseline="central"
              textAnchor="middle">
              {initial}
            </text>
          </svg>
        </div>
      )
    }
  }
}
  
export default DefaultUserPicture

const sessionMapStateToProps = state => ({
  displayName: state.getIn(['session','user','displayName']),
  profilePicture: state.getIn(['session','user','profilePicture'])
})
const SessionDefaultUserPicture = connect(
  sessionMapStateToProps
)(DefaultUserPicture)

const profileMapStateToProps = state => ({
  displayName: state.getIn(['profile','userInfo','displayName']),
  profilePicture: state.getIn(['profile','userInfo','pictureUrl'])
})
const ProfileDefaultUserPicture = connect(
  profileMapStateToProps
)(DefaultUserPicture)

export {SessionDefaultUserPicture, ProfileDefaultUserPicture}


// WEBPACK FOOTER //
// ./src/core/components/default-user-picture/DefaultUserPicture.js